import { render, staticRenderFns } from "./TxtViewer.vue?vue&type=template&id=3375db3f&scoped=true&"
import script from "./TxtViewer.vue?vue&type=script&lang=ts&"
export * from "./TxtViewer.vue?vue&type=script&lang=ts&"
import style0 from "./TxtViewer.vue?vue&type=style&index=0&id=3375db3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3375db3f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VBtn,VIcon,VProgressCircular,VSpacer,VToolbarTitle})
